// import Vue from 'vue'
// import {
//   AllPagesMessage,
//   CurrentPageMessage,
//   DoneRenderingPdfMessage,
//   GrabbingDoneMessage,
//   GrabbingStoppedMessage, PagesInBetweenMessage,
//   PdfRotationMessage,
//   StartEntirePageGrabMessage
// } from './constants/pdf-messages'
// export const EventBus = new Vue();

// window.addEventListener('message', function (e) {
//   switch (e.data.message) {
//     case GrabbingDoneMessage:
//       EventBus.$emit(GrabbingDoneMessage, e);
//       break;
//     case GrabbingStoppedMessage:
//       EventBus.$emit(GrabbingStoppedMessage, e);
//       break;
//     case 'refreshMessage':
//       EventBus.$emit('refreshMessage', e);
//       break;
//     case StartEntirePageGrabMessage:
//       EventBus.$emit(StartEntirePageGrabMessage);
//       break;
//     case PdfRotationMessage:
//       EventBus.$emit(PdfRotationMessage, e);
//       break;
//     case DoneRenderingPdfMessage:
//       EventBus.$emit(DoneRenderingPdfMessage);
//       break;
//     case CurrentPageMessage:
//       EventBus.$emit(CurrentPageMessage, e);
//       break;
//     case PagesInBetweenMessage:
//       EventBus.$emit(PagesInBetweenMessage, e);
//       break;
//     case AllPagesMessage:
//       EventBus.$emit(AllPagesMessage, e);
//       break;
//   }
// });
import mitt from 'mitt';
import {
  AllPagesMessage,
  CurrentPageMessage,
  DoneRenderingPdfMessage,
  GrabbingDoneMessage,
  GrabbingStoppedMessage,
  PagesInBetweenMessage,
  PdfRotationMessage,
  StartEntirePageGrabMessage
} from './constants/pdf-messages';

const EventBus = mitt(); // Vue 3 replacement for event bus

// ? Attach the event bus globally if needed
export default EventBus;

// ? Ensure global window event listeners remain functional
//
// These are the PDF viewer's replies (public/pdf/viewer.html, served from this
// origin and framed by PdfDoc, ReportDoc and the extraction preview). Any page
// that holds a reference to this window can post to it, so a message from
// another origin is not the viewer's and is ignored - it could otherwise fake a
// finished grab, a rotation or a page request.
window.addEventListener('message', function (e) {
  if (e.origin !== window.location.origin || !e.data || typeof e.data !== 'object') return;

  switch (e.data.message) {
    case GrabbingDoneMessage:
      EventBus.emit(GrabbingDoneMessage, e);
      break;
    case GrabbingStoppedMessage:
      EventBus.emit(GrabbingStoppedMessage, e);
      break;
    case 'refreshMessage':
      EventBus.emit('refreshMessage', e);
      break;
    case StartEntirePageGrabMessage:
      EventBus.emit(StartEntirePageGrabMessage);
      break;
    case PdfRotationMessage:
      EventBus.emit(PdfRotationMessage, e);
      break;
    case DoneRenderingPdfMessage:
      EventBus.emit(DoneRenderingPdfMessage, e);
      break;
    case CurrentPageMessage:
      EventBus.emit(CurrentPageMessage, e);
      break;
    case PagesInBetweenMessage:
      EventBus.emit(PagesInBetweenMessage, e);
      break;
    case AllPagesMessage:
      EventBus.emit(AllPagesMessage, e);
      break;
  }
});

